import * as React from "react";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import {useEffect} from "react";
import {withNavigation} from "../navigation/navigation";
import {Stack, Typography, Paper, Box, Divider, Button, Breadcrumbs, TextField, Link} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import LinearProgress from '@mui/material/LinearProgress';
import {useOrderDetail} from './hooks/useOrderDetail';
import {withOrderDetailContext} from "./state/orderDetailContext";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {Customer} from "./queries/Customer";
import DoneIcon from '@mui/icons-material/Done';
import {useServiceFavorite} from "../service/hook/useServiceFavorite";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import {withServiceListContext} from "../service/state/serviceContext";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";


const OrderDetail = ({setShowNav}) => {
    const {mode} = useDarkMode();
    const {id} = useParams();
    const {detail, loading} = useOrderDetail(parseInt(id));
    console.log('detail', detail)
    const {addToFavorite, removeFromFavorite} = useServiceFavorite();
    const [favorite, setFavorite] = React.useState(true);
    const [idWhistListProduct, setIdWhistListProduct] = React.useState(null);

    const [value, setValue] = React.useState();

    const [showList, setShowList] = React.useState(false);

    const [showTextArea, setShowTextArea] = React.useState(false);

    const [textAreaValue, setTextAreaValue] = React.useState('');

    const [successReport, setSuccessReport] = React.useState(false);

    useEffect(() => {
        setFavorite(true);
        if (detail && detail.product) {
            console.log('detail.product.favorite', detail.product.favorite)
            setFavorite(detail.product.favorite);
            setIdWhistListProduct(detail.product.wishListIdProduct);
        }
    }, [detail]);

    const handleChange = (event) => {
        setValue(event.target.value);
        if (event.target.value === '4') {
            setShowTextArea(true);
        } else {
            setShowTextArea(false);
            setTextAreaValue('');
        }
    };

    const handleClick = () => {
        const url = detail.invoiceUrl; // Replace with your URL
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const sendForm = async () => {
        try {
            const res = await Customer.sendReport(value, detail.orderId, detail.customerId, textAreaValue);
            if (res.status === 201) {
                setSuccessReport(true);
                setShowTextArea(false);
                setTextAreaValue('');
                setShowList(false);
                return true;
                console.log('Form sent:', res);
            }
            return false;
        } catch (err) {
            console.log('err', err)
        }

    }

    const navigate = useNavigate();

    useEffect(() => {
        setShowNav(false);
    }, []);

    const breadcrumbs = [
        <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
        </Typography>,
        <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/order-history')} style={{color : mode.settings.breadcrumbColor1}}>
            Mes commandes
        </Typography>,
        <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
            Détail de la commande
        </Typography>,
    ];

    return (
        !loading && detail &&  <Stack>
            <Breadcrumbs
                separator="›"
                aria-label="navigation"
                style={{color: mode.settings.textColor3, marginTop : '15px', marginBottom : '15px'}}>
                {breadcrumbs}
            </Breadcrumbs>
            <Paper
                style={{
                    backgroundColor: mode.settings.cardBackgroundColor,
                    width: 'inherit',
                    maxWidth : '1000px',
                    padding : '10px'
                }}
            >

                <Stack direction={'row'} spacing={3} flexWrap={'wrap'} justifyContent={'center'} gap={'10px'}>
                    <Stack direction={'row'} spacing={2}  flexWrap={'wrap'} justifyContent={'center'}>
                        <Stack spacing={2 }>
                            <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                <Typography variant={"subtitle13"} sx={{color : mode.settings.textColor3}}>{detail.title}</Typography>
                                {
                                    favorite === true ?
                                        <StarIcon
                                            sx={{color : '#EFBA00'}}
                                            fontSize={'large'}
                                            onClick={() => {
                                                const done = removeFromFavorite(id, idWhistListProduct) ;
                                                if (done) {
                                                    setFavorite(false);
                                                }
                                            }}

                                        />:
                                        <StarBorderIcon
                                            sx={{color : '#EFBA00'}}
                                            fontSize={'large'}
                                            onClick={ async () => {
                                                const resId = await addToFavorite(detail.product.id, detail.product.wishlistId);
                                                if (resId) {
                                                    setFavorite(true);
                                                    setIdWhistListProduct(resId);
                                                }
                                            }}
                                        />
                                }
                            </Stack>
                            <Stack direction={'row'} spacing={2} flexWrap={'wrap'} justifyContent={'center'}>
                                <Stack spacing={2}>
                                    <Box
                                        sx={{
                                            height: '256px',
                                            width: '301px',
                                            backgroundImage: `url(${detail.product.image})`
                                        }}
                                    />
                                    {/*<Stack sx={{ width: '100%', color: 'grey.500' }} direction={'row'} alignItems={'center'}>*/}
                                    {/*    <Box sx={{width : '20px', height : '20px', backgroundColor: "#3E9FDD", borderRadius: "50%"}}/>*/}
                                    {/*    <LinearProgress color={"primary"} sx={{ width: '33%'}} value={50} variant="determinate"/>*/}
                                    {/*    <Box sx={{width : '20px', height : '20px', backgroundColor: "#54985B", borderRadius: "50%"}}/>*/}
                                    {/*    <LinearProgress color={"success"} sx={{ width: '33%'}} value={50} variant="determinate"/>*/}
                                    {/*    <Box sx={{width : '20px', height : '20px', backgroundColor: "#B82424", borderRadius: "50%"}}/>*/}
                                    {/*    <LinearProgress color={"error"} sx={{ width: '33%'}} value={50} variant="determinate"/>*/}
                                    {/*</Stack>*/}
                                    {
                                        detail.product.payment_type == 1 ?
                                            <Button onClick={handleClick}
                                                    className=""
                                                    variant="contained"
                                                    size="large"
                                                    disabled={true}
                                            >
                                                Télécharger la facture
                                            </Button>
                                            :
                                            <Button onClick={handleClick}
                                                    className="btn-gradient"
                                                    variant="contained"
                                                    size="large"

                                            >
                                                Télécharger la facture
                                            </Button>
                                    }

                                </Stack>

                                <Stack spacing={2}>
                                    <Stack direction={'column'} alignItems={'flex-start'} justifyContental={'space-between'} width={'100%'} gap={1} maxWidth={'300px'}>
                                        {
                                            detail.formValues && detail.formValues.map((item, index) => {
                                                return (
                                                    <Stack direction={'column'} alignItems={'flex-start'} gap={1} key={index}>
                                                        <Typography variant={'subtitle8'} color={mode.settings.textColor3}>{item.label}</Typography>
                                                        <Typography variant={'subtitle6'} color={mode.settings.textColor3}>{item.value}</Typography>
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>
                                </Stack>
                            </Stack>

                        </Stack>

                    </Stack>
                    <Stack
                        sx={{
                            width : '100%',
                            maxWidth : '340px',
                            minWidth : '340px',
                            borderWidth: '1px',
                            borderStyle :'solid',
                            borderColor : '#BCC1CD',
                            borderRadius : '5px',
                            padding : '10px',
                            marginLeft : '0px !important'
                        }}
                        gap={'10px'}
                    >
                        <Stack spacing={2}>
                            <Typography variant={'h2'} sx={{color : mode.settings.textColor3}}>Ma commande</Typography>
                            <Divider />
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>Quantité</Typography>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>{detail.quantity}</Typography>
                            </Stack>
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>Livraison</Typography>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>{parseFloat(detail.shipping).toFixed(2).replace('.', ',') } €</Typography>
                            </Stack>
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>Prix du service</Typography>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>{parseFloat(detail.price).toFixed(2).replace('.', ',') } €</Typography>
                            </Stack>
                            <Divider />
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>Total</Typography>
                                <Typography variant={'subtitle10'} sx={{color : mode.settings.textColor3}}>{parseFloat(detail.total).toFixed(2).replace('.', ',') } €</Typography>
                            </Stack>
                        </Stack>
                        {!successReport && <Button
                            sx={{
                                width: '100%',
                                height : '39px',
                                backgroundColor : '#3E9FDD',
                                color : 'white',
                                borderRadius : '5px'
                            }}
                            onClick={() => {
                                setShowList(true);
                            }}
                        >
                            <Typography variant={'subtitle6'}>Signaler un problème</Typography>
                        </Button>}
                        {showList && <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={value}
                                onChange={handleChange}
                            >
                                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography color={mode.settings.textColor3}>Non livré ou service non réalisé</Typography>
                                    <FormControlLabel  labelPlacement="start" value="1" control={<Radio sx={{color :mode.settings.textColor3}}/>}/>
                                </Stack>
                                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography color={mode.settings.textColor3}>Endomagé ou service non satisfaisant</Typography>
                                    <FormControlLabel labelPlacement="start" value="2" control={<Radio sx={{color :mode.settings.textColor3}}/>}/>
                                </Stack>
                                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography color={mode.settings.textColor3}>Mauvais produit</Typography>
                                    <FormControlLabel labelPlacement="start" value="3" control={<Radio sx={{color :mode.settings.textColor3}}/>}/>
                                </Stack>
                                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography color={mode.settings.textColor3}>Autre</Typography>
                                    <FormControlLabel labelPlacement="start" value="4" control={<Radio sx={{color :mode.settings.textColor3}}/>}/>
                                </Stack>
                            </RadioGroup>
                            {showTextArea && <TextField
                                value={textAreaValue}
                                label="Ajouter un autre"
                                // variant="filled"
                                onChange={event => setTextAreaValue(event.target.value)}
                                sx={{background: mode.settings.inputBackgroundColor}}
                                InputProps={{
                                    inputProps: {style: {color: mode.settings.textColor3}},
                                }}
                                InputLabelProps={{style: {color: mode.settings.textColor3}}}
                                multiline={true}
                                rows={3}
                                maxRows={6}
                                style={{marginBottom : '10px'}}
                            />}
                            <Stack direction={'row'} justifyContent={'space-between'} gap={'10px'}>
                                <Button
                                    sx={{
                                        width: '100%',
                                        height : '39px',
                                        backgroundColor : mode.settings.color15,
                                        color : 'white',
                                        borderRadius : '5px'
                                    }}
                                    onClick={() => {
                                        setShowList(false);
                                        setValue();
                                        setShowTextArea(false);
                                        setTextAreaValue('');
                                    }}
                                >
                                    <Typography variant={'subtitle6'} color={mode.settings.textColor}>Annuler</Typography>
                                </Button>
                                <Button
                                    sx={{
                                        width: '100%',
                                        height : '39px',
                                        backgroundColor : mode.settings.footerBackgroundColor,
                                        color : 'white',
                                        borderRadius : '5px'
                                    }}
                                    onClick={() => {
                                        sendForm()
                                    }}
                                >
                                    <Typography variant={'subtitle6'} color={'white'}>Envoyer</Typography>
                                </Button>
                            </Stack>
                        </FormControl>}
                        {successReport && <Stack direction={'row'}
                               style={{
                                   backgroundColor : '#DFFFE8',
                                   padding : '8px',
                                   gap : '10px',
                                   borderLeft : '3px',
                                   borderLeftColor : '#25A249',
                                   borderLeftStyle : 'solid'
                                }}
                               alignItems={'center'}
                        >
                            <DoneIcon style={{color : '#25A249'}}/>
                            <Stack direction={'column'} gap={'5px'}>
                                <Typography variant={'subtitle8'} sx={{color : mode.settings.color14}}>
                                    Merci pour votre signal,
                                </Typography>
                                <Typography variant={'subtitle6'} sx={{color : mode.settings.color14}}>
                                    nous vous reviendrons dans les plus brefs délais.
                                </Typography>
                            </Stack>
                        </Stack>}
                    </Stack>
                </Stack>
            </Paper>
        </Stack>

    )
}

export default withNavigation(withOrderDetailContext(withServiceListContext(OrderDetail)))
